import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Button,
  Form,
  FormGroup,
  Input,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIpasswordReset } from '../../api/Auth';

import {
  getEmailFromParam,
  parseResponseErrors,
} from '../../helpers';

import ErrorBoundary from '../../components/ErrorBoundary';

class PasswordResetResetForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: getEmailFromParam(),
      error: null,
      success: false,
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { state } = this;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({
      loading: true,
      error: null,
    });

    if (!this.isFormValid()) {
      this.setState({ loading: false });
      return;
    }

    const { email } = this.state;

    APIpasswordReset(email).then((response) => {
      if (parseInt(response.status) === 200) {
        this.setState({ success: true });
      } else {
        let errorMessage = 'Invalid email address';
        if (response.data && response.data.message) {
          errorMessage = response.data.message;
        }
        this.setState({
          error: errorMessage,
          loading: false,
        });
      }
    }).catch((error) => {
      this.setState({
        error: Object.values(parseResponseErrors(error.response)).join(', '),
        loading: false,
      });
    });
  }

  isFormValid() {
    const { email } = this.state;

    if (!email) {
      this.setState({ error: 'Please enter your email address' });
      return false;
    }

    return true;
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      email,
      error,
      success,
      loading,
    } = this.state;

    return (
      <ErrorBoundary>
        {success ? (
          <div className="center">
            <p>
              {intl.formatMessage(
                { defaultMessage: 'A password reset link has been sent to the email you provided.{br}Click the link in the email to reset your password.' },
                { br: <br /> },
              )}
            </p>
          </div>
        ) : (
          <Form
            className="login-form"
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}
          >
            <div>
              <p>{intl.formatMessage({ defaultMessage: 'Enter your email to reset your password' })}</p>
            </div>
            {error && (
              <div className="error">
                {error}
              </div>
            )}
            <div className="groups-wrapper">
              <FormGroup>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                  disabled={loading}
                  defaultValue={email}
                />
              </FormGroup>
            </div>
            <div className="login-forgot">
              <Link to="/login">
                {intl.formatMessage({ defaultMessage: 'Back to Login' })}
              </Link>
            </div>
            <div className="btn-wrapper">
              <Button
                type="submit"
                disabled={loading}
                color="primary"
              >
                {loading ? intl.formatMessage({ defaultMessage: 'Please wait...' }) : intl.formatMessage({ defaultMessage: 'Reset password' })}
              </Button>
            </div>
          </Form>
        )}
      </ErrorBoundary>
    );
  }
}

PasswordResetResetForm.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default injectIntl(PasswordResetResetForm);
